import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Experience } from './Experience';
export var ExperienceTracker = /*#__PURE__*/function () {
  function ExperienceTracker(options) {
    _classCallCheck(this, ExperienceTracker);
    _defineProperty(this, "experiences", {});
    _defineProperty(this, "subscribers", []);
    this.isNetworkOfflineError = options && options.isNetworkOfflineError || function () {
      return false;
    };
  }
  return _createClass(ExperienceTracker, [{
    key: "start",
    value: function start(_ref) {
      var _this = this;
      var name = _ref.name,
        id = _ref.id,
        timeout = _ref.timeout,
        startTime = _ref.startTime,
        attributes = _ref.attributes,
        onSuccess = _ref.onSuccess,
        onFailure = _ref.onFailure,
        onAbort = _ref.onAbort,
        collect = _ref.collect;
      var current = this.experiences[name];
      if (current && !current.hasStopped && current.id === id) {
        return;
      }

      // Before replacing a current experience, abort it to ensure
      // it is cleaned up.
      if (current) {
        current.abort({
          reason: 'Aborted because the same experience was started with a new id'
        });
      }
      var experience = new Experience({
        name: name,
        id: id,
        timeout: timeout,
        startTime: startTime,
        attributes: attributes,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onAbort: onAbort,
        onStart: function onStart(startEvent) {
          _this.emit(startEvent);
          var disposeCollectSubscription = function disposeCollectSubscription() {};
          if (collect) {
            var _events = [];
            disposeCollectSubscription = _this.subscribe(function (event) {
              // Ignore already running experiences that started before this
              // experience started
              if (event.action === 'taskStart' || _events.some(function (previousEvent) {
                return previousEvent.name === event.name && previousEvent.action === 'taskStart';
              })) {
                _events.push(event);
                collect(_events, experience);
              }
            });
          }
          return function (stopEvent) {
            disposeCollectSubscription();
            _this.emit(stopEvent);
          };
        }
      });
      this.experiences[name] = experience;
    }
  }, {
    key: "succeed",
    value: function succeed(_ref2) {
      var name = _ref2.name,
        attributes = _ref2.attributes;
      var current = this.experiences[name];
      if (!current) {
        return;
      }
      current.succeed(attributes);
    }
  }, {
    key: "fail",
    value: function fail(_ref3) {
      var name = _ref3.name,
        error = _ref3.error,
        attributes = _ref3.attributes;
      Object.values(this.experiences).forEach(function (current) {
        if (name != null && current.name !== name) {
          return;
        }
        current.fail({
          error: error,
          attributes: attributes
        });
      });
    }
  }, {
    key: "abort",
    value: function abort(_ref4) {
      var name = _ref4.name,
        reason = _ref4.reason,
        attributes = _ref4.attributes,
        checkForTimeout = _ref4.checkForTimeout;
      function abort(experience) {
        if (name != null && experience.name !== name) {
          return;
        }
        experience.abort({
          reason: reason,
          checkForTimeout: checkForTimeout,
          attributes: attributes
        });
      }
      var experiencesWithTimeouts = Object.values(this.experiences).filter(function (experience) {
        return experience.timeout;
      });
      var experiencesWithoutTimeouts = Object.values(this.experiences).filter(function (experience) {
        return !experience.timeout;
      });

      // We need to abort all experiences with timeouts first in order to properly
      // capture compound experiences composed of sub-experiences which have timeouts
      experiencesWithTimeouts.forEach(abort);
      experiencesWithoutTimeouts.forEach(abort);
    }
  }, {
    key: "subscribe",
    value: function subscribe(subscriber) {
      var _this2 = this;
      if (typeof subscriber !== 'function') {
        throw new Error('Subscriber must be a function');
      }
      this.subscribers.push(subscriber);
      return function () {
        _this2.subscribers = _this2.subscribers.filter(function (x) {
          return x !== subscriber;
        });
      };
    }
  }, {
    key: "stopOnError",
    value: function stopOnError(_ref5) {
      var name = _ref5.name,
        error = _ref5.error,
        attributes = _ref5.attributes;
      if (this.isNetworkOfflineError(error)) {
        this.abort({
          name: name,
          reason: "Aborted ".concat(name, " because of network error: ").concat(error.toString()),
          checkForTimeout: false,
          attributes: attributes
        });
        return;
      }
      return this.fail({
        name: name,
        error: error,
        attributes: attributes
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      this.subscribers.forEach(function (subscriber) {
        try {
          subscriber(event);
        } catch (e) {
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.error("Error occurred in ExperienceTracker subscriber when handling an event.", 'Error:', e, 'Event:', event);
          }
        }
      });
    }
  }]);
}();